import { memoize } from "lodash";
import { apiCallGetKhattabatDataCollection } from "../../../api/supervisor-api/api-call-get-khattabat-data-collection";
import { observable, runInAction } from "mobx";
import { TKhattabatClientData, TKhattabatDataCollection } from "../../../Types";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";
import { apiCallGetAllKhattabatClientsData } from "../../../api/supervisor-api/api-call-get-all-khattabat-clients-data";
import { exportToCSV } from "../../../helpers/general";
import { ALL_KHATTABAT_CLIENTS_DATA_HEADERS } from "../../../constants/table-custom-headers/Khattabat";

class SupervisorKhattabatData {
  khattabatDataCollection = observable.box<TKhattabatDataCollection>([]);
  allKhattabatClientsData = observable.box<TKhattabatClientData>([]);

  setKhattabatDataColletion = (data: TKhattabatDataCollection) => {
    runInAction(() => {
      this.khattabatDataCollection.set(data);
    });
  };

  setAllKhattabatClientsData = (data: TKhattabatClientData) => {
    const formattedData = data.map((item) => ({
      ...item,
      cancelled: item.cancelled ? "Yes" : "No",
      active: item.active ? "Yes" : "No"
    }));

    runInAction(() => {
      this.allKhattabatClientsData.set(formattedData);
    });
  };

  getKhattabatDataCollection = async () => {
    getCoreUIStore().setIsLoading("KHATTABAT_DATA_COLLECTION", true);
    const { data, status, code } = await apiCallGetKhattabatDataCollection();
    getCoreUIStore().setIsLoading("KHATTABAT_DATA_COLLECTION", false);
    if (status === "OK") {
      this.setKhattabatDataColletion(data);
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };

  getAllKhattabatClientsData = async () => {
    getCoreUIStore().setIsLoading("KHATTABAT_DATA_COLLECTION", true);
    const { data, status, code } = await apiCallGetAllKhattabatClientsData();
    getCoreUIStore().setIsLoading("KHATTABAT_DATA_COLLECTION", false);
    if (status === "OK") {
      this.setAllKhattabatClientsData(data);
      exportToCSV(
        this.allKhattabatClientsData.get(),
        ALL_KHATTABAT_CLIENTS_DATA_HEADERS
      );
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };
}

export const SupervisorKhattabatDataStore = memoize(
  () => new SupervisorKhattabatData(),
  () => 1
);
